<template>
    <div name="confirm-modal" class="wrapper">
        <div class="modal">
            <div class="touch" @click="onCancel">

            </div>
            <div class="contents">
                <span class="title">{{ title }}</span>
                <span class="text">{{ text1 }}</span>
                <span class="text">{{ text2 }}</span>
                <div class="row" style="margin-top: 10px;">
                    <bottom-button 
                        :text="'확인'"
                        :color="'var(--Gray-100, #1E1E1E)'"
                        @onClick="onYes"
            
                    />
                    <bottom-button 
                        :text="'취소'"
                        :color="'#FFFFFF'"
                        @onClick="onCancel"
                    />
                </div>

            </div>
        </div>
    </div>
</template>

<script>
import BottomButton from '@/components/atoms/BottomButton';
export default {
    name: 'confirmModal',
    props: ['title', 'text1', 'text2'],
    components: {BottomButton},
    methods: {
        onYes: function()
        {
            this.$emit('onYes')
        },
        onCancel: function()
        {
            this.$emit('onCancel')
        }
    }
}
</script>

<style scoped>
    .wrapper {
        width: 100%;
        display: flex;
        justify-content: center;
        align-items: center;

    }
    .modal {
        position: fixed;
        background: rgba(0, 0, 0, 0.7);
        max-width: 600px;
        width: 100%;
        height: 100vh;
        z-index: 10;
        bottom: 0;
        box-sizing: border-box;
    }
    .touch {
        height: calc(100vh - 339px);
        width: 100vw;
    }
    .contents {
        background: #FFFFFF;
        height: 339px;
        width: 100%;
        border-top-left-radius: 20px;
        border-top-right-radius: 20px;
        padding: 34px 16px 30px 16px;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        align-items: flex-start;
        box-sizing: border-box;
    }
    .text {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 20px;
        font-style: normal;
        font-weight: 400;
        line-height: 22px; /* 110% */
    }
    .title {
        color: #1E1E1E;
        font-family: Pretendard;
        font-size: 24px;
        font-style: normal;
        font-weight: 500;
        line-height: 28px; /* 116.667% */
    }
    .row {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
</style>


// WEBPACK FOOTER //
// src/components/modals/calculator/ConfirmModal.vue